export default __webpack_public_path__ + "static/media/gallery10.51cfa9e3.jpg";